// Assuming images are in a path like 'src/assets/images/'
// Adjust paths as per your project structure.
// If these images are in the public folder, the paths would be different (e.g., '/images/samuel.jpg')

import samuelImage from '../assets/samuel.jpg';
import jeremyImage from '../assets/jeremy.jpg';
import ashleyImage from '../assets/ashley.jpg';
import markImage from '../assets/mark.jpg';
import finlayImage from '../assets/finlay.jpg';
import louisImage from '../assets/louis.jpg';
import danielImage from '../assets/daniel.jpg';

export const staffMembers = [
  {
    id: 'smunday',
    name: 'Sam Munday',
    role: 'Director',
    image: samuelImage,
    alt: 'Photo of Sam Munday',
    bio: 'Sam drives the strategic direction of Data Revival. He cultivates a team culture built on experimentation and forward momentum.',
    skills: ['Strategic Leadership', 'Product Development', 'Innovation Management'],
  },
  {
    id: 'jfrey',
    name: 'Prof. Jeremy Frey',
    role: 'Director',
    image: jeremyImage,
    alt: 'Photo of Jeremy Frey',
    bio: "Jeremy brings decades of experience at the intersection of chemistry and information systems, and his collaborations with academia help bridge frontier research with industry relevance.",
    skills: ['Chemical Informatics', 'Scientific Research', 'Academic Collaboration'],
  },
  {
    id: 'aunitt',
    name: 'Ashley Unitt',
    role: 'Advisor',
    image: ashleyImage,
    alt: 'Photo of Ashley Unitt',
    bio: 'Ashley applies his experience in scaling tech ventures to help Data Revival navigate startup dynamics, define market fit, and unlock strategic opportunities.',
    skills: ['Startup Advisory', 'Tech Commercialization'],
  },
  {
    id: 'mgoulding',
    name: 'Mark Goulding',
    role: 'Advisor',
    image: markImage,
    alt: 'Photo of Mark Goulding',
    bio: 'Mark lends his expertise in enterprise technology and growth strategy to help Data Revival build systems that are as robust as they are visionary. His insights help align technical infrastructure with business outcomes.',
    skills: ['Enterprise Systems', 'Market Strategy', 'Business Growth'],
  },
  {
    id: 'fmorrison',
    name: 'Finlay Morrison',
    role: 'Lead Data Scientist',
    image: finlayImage,
    alt: 'Photo of Finlay Morrison',
    bio: 'Finlay leads the design of cutting-edge machine learning pipelines at Data Revival. His work focuses on optimizing model performance and deploying scalable APIs that extract signal from noisy, high-dimensional chemical datasets.',
    skills: ['Machine Learning', 'Model Optimization', 'API Development'],
  },
  {
    id: 'lmclean',
    name: 'Louis McLean',
    role: 'AI Engineer',
    image: louisImage,
    alt: 'Photo of Louis McLean',
    bio: 'Louis engineers the AI foundations that power Data Revival\'s platform. From LLM systems to special-purpose models, he brings theory into practice',
    skills: ['AI Engineering', 'Software Development', 'NLP'],
  },
  {
    id: 'dcancado',
    name: 'Daniel Cançado',
    role: 'Data Engineer',
    image: danielImage,
    alt: 'Photo of Daniel Cançado',
    bio: 'Daniel builds and optimizes the data infrastructure at the heart of Data Revival. His expertise spans data curation, labeling strategy, and labelling pipelines, designed to handle the unique challenges of scientific data at scale.',
    skills: ['Data Curation', 'Big Data Technologies', 'Labelling Strategy'],
  },
];